<template>
    <div>
        <div class="addEmailForm">
            <Form :form="addEmailForm" @handleSelectChange="handleSelectChange" :style="{display:'flex',flex:'4'}">
                <template v-slot:formBtn>
                    <a-button v-permission="'setting.sysSetting.addEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                        <icon-plus-circle size="13" style="marginRight:5px;"/>
                        {{ $t('base.add') }}
                    </a-button>
                </template>
            </Form>
            <a-input-search 
                :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                v-model="email"
                allow-clear 
                @press-enter="pressEnter" 
                @search="search" 
                @clear="pressEnter"
                :placeholder="t('base.enterEmail')" 
             />
        </div>
        
            
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.sysSetting.deleteEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                    <icon-delete size="13" style="marginRight:5px;"/>
                    {{ $t('order.delete') }}
                </a-button>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { RoleApi } from '@/api/RoleApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { AddEmailForm } from './queryConfig/SettingForm.js';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const addEmailForm = reactive(AddEmailForm)
    const email = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('setting.email'),
                dataIndex: 'email',
                key:'sku',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'add':
                let pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
                let bool = pattern.test(addEmailForm.formData.email)
                if(!addEmailForm.formData.email){
                    Message.error(t('setting.emailMsg'))
                    return
                }
                if(!bool){
                    Message.error(t('setting.emailFormat'))
                    return
                }

                
                save()
                break;
            case 'delete':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        console.log(row,'id')
                        del(row)
                    }
                });
                break;
        }
    }

    const pressEnter = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        email.value = val
        getList()
    }

    const handleSelectChange = (val)=>{
        console.log(val,'vvvv')
        if(val){
            const item = addEmailForm.formField.find(i=>i.key == 'sku')
            const opt = item.options.find(i=>i.value == val)
            addEmailForm.formData.inventoryCode = opt.code
        }else{
            addEmailForm.formData.inventoryCode = ''
        }
       
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        console.log(pageSize,'pageSize')
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getList()
    }

    // 获取列表
    const getList = async ()=>{
        let param = {
            dict_code: "config", 
            dict_sub_code:'email',
            dict_sub_name:email.value,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await RoleApi.getInstance().getList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 保存
    const save = async ()=>{
        let param = {
            dict_code: "config", 
            dict_sub_code:'email',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await RoleApi.getInstance().addEmail(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 删除
    const del = async (row)=>{
        let res = await RoleApi.getInstance().delEmail(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getList()
    })
</script>

<style lang="less" scoped>
.addEmailForm{
    display: flex;
    background: #fff;
    padding: 10px 20px;

    .form_btn{
        margin-left: -100px;
    }
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}
</style>